module.exports = __webpack_public_path__ + "static/media/Inventory Management.69e70ff4.svg";